import { AGENT_MODEL_CATALOG } from './agent-profile.js';
// =============================================================================
// v2.0.0 PR #A-bis — Multi-provider LLM keys
// =============================================================================
export const LLM_PROVIDERS = ['openai', 'anthropic', 'deepseek', 'gemini'];
/**
 * Legacy Settings → Defaults dropdown. Same ids as the OpenAI offline
 * catalog. Agent model pickers use GET /admin/llm-models instead.
 */
export const SUPPORTED_CHAT_MODELS = AGENT_MODEL_CATALOG.openai;
export const SUPPORTED_WHISPER_MODELS = ['whisper-1'];
export const SUPPORTED_EMBEDDING_MODELS = [
    'text-embedding-3-small',
    'text-embedding-3-large',
];
//# sourceMappingURL=settings.js.map